(function (angular) {
	'use strict';

	var featureService = function ($stateParams, $q, $http, auth) {
		let featureflagsPromise = {};

		const getFeatures = siteName => {
			if (featureflagsPromise[siteName] != null) {
				return featureflagsPromise[siteName];
			}

			featureflagsPromise[siteName] = $http
				.get('api/' + siteName + '/featureflags/')
				.then(function (response) {
					return {
						places: response.data.places,
						socialMedia: response.data.socialMedia,
						listings: response.data.listings,
						accountSettings: response.data.accountSettings
					};
				})
				.catch(() => {
					featureflagsPromise[siteName] = null;
					return {
						places: {},
						socialMedia: {},
						listings: {}
					};
				});

			return featureflagsPromise[siteName];
		};

		var checkFeature = function (features, feature) {
			var parts = (feature || '').split('.');
			var featureEnabled =
				features[parts[0]] && features[parts[0]][parts[1]] && features[parts[0]][parts[1]].enabled;
			return featureEnabled;
		};

		var checkSiteLevelFeatures = function (site, feature) {
			if (site == null) {
				return false;
			}
			var features = {
				socialMedia: (site.socialMedia || {}).feature,
				places: (site.places || {}).feature,
				accessmanagement: (site.accessmanagement || {}).feature,
				listenRespond: (site.listenRespond || {}).feature
			};

			return checkFeature(features, feature);
		};

		var checkSystemLevelFeatures = function (features, feature) {
			return checkFeature(features, feature);
		};

		this.hasFeature = function (feature) {
			return $q
				.all([auth.getUser($stateParams.site), getFeatures($stateParams.site)])
				.then(results => {
					const user = results[0];
					const features = results[1];

					if (
						checkSystemLevelFeatures(features, feature) ||
						checkSiteLevelFeatures(user.selectedSite, feature)
					) {
						return true;
					} else {
						return false;
					}
				});
		};

		this.getFeatures = getFeatures;
	};

	angular
		.module('PinMeTo.featureFlag')
		.service('pmtFeatureFlagService', ['$stateParams', '$q', '$http', 'auth', featureService]);
})(window.angular);
